// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2oHwj","loaderOuter":"PageOverlayLoader_loaderOuter__3iORY"};